var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewer",staticClass:"vue_viewer"},[[_c('div',{staticClass:"vue_viewer_wrapper"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"vue_viewer_item"},[_c('img',{attrs:{"src":item}})])}),0)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }